export default __webpack_public_path__ + "static/media/tech.a38d4af6.png";